import React, { useState } from 'react';

import { Row, Col, Label, FormGroup } from 'twyne-new.ui';

import Input from 'components/formsy/Input';

import APICkecker from '../APICkecker'

export default function Ifficient({ name, data = {} }) {
  const [username, setUsername] = useState(data.username || '')
  const [password, setPassword] = useState(data.password || '')

  return <>
    <Row>
      <Col size='6'>
        <FormGroup>
          <Label>Username</Label>
          <Input required
            name="username"
            value={username}
            onChange={setUsername}
          />
        </FormGroup>
      </Col>
      <Col size='6'>
        <FormGroup>
          <Label>Password</Label>
          <Input type="password" required
            name="password"
            value={password}
            onChange={setPassword}
          />
        </FormGroup>
      </Col>
    </Row>
    <APICkecker
      partner={name}
      credentials={{ username, password }}
    />
  </>
}
